import { EstadosAgendamientoEnumChoice, EstadosContratoChoiceEnum, ModulosEnumChoice, a11yProps, sizeTab, useCheckPermissions } from "@/shared";
import { Box, Tab, Tabs } from "@mui/material";
import { useEffect, useState } from "react";
import { CustomTabPanel } from "../..";
import { SingleTableBoxScene } from "@/shared/components/ui";
import { PermissionsEnum } from "@/auth/interfaces";
import AgendamientoAgendadoPage from "./shared/componente/agendamiento-agendando/AgendamientoAgendadoTable";
import { useDiccionarioMotivo } from "@/store/erp/diccionario_motivo/diccionario_motivo.store";
import AgendamientoRecodianadoTable from "./shared/componente/agendamiento-agendando/AgendamientoRecodianadoTable";


const AgendamientoVentaPage = () => {

  useCheckPermissions(PermissionsEnum.api_view_agendamiento);

  //STATE
  const [valueTab, setValueTab] = useState(0);

  const setFaseVenta = useDiccionarioMotivo().setFaseVenta

  useEffect(() => {
    setFaseVenta(ModulosEnumChoice.AGENDAMIENTO);
  }, [])

  return (
    <SingleTableBoxScene
      title={"Agendadas Ventas"}
    >
      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs preventa"
        >
          <Tab label={'Agendamiento'} value={0} {...a11yProps(0)} />
          <Tab label={'Recoordinadas'} value={1} {...a11yProps(1)} />
        </Tabs>
      </Box>

      <CustomTabPanel value={valueTab} index={0}>
        <AgendamientoAgendadoPage
          estado_agendamiento={EstadosAgendamientoEnumChoice.FINALIZADO}
          estado_contrato_exclude={EstadosContratoChoiceEnum.ACTIVO}
        />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={1}>
        <AgendamientoRecodianadoTable enableActions={true} />
      </CustomTabPanel>
    </SingleTableBoxScene>
  );
}

export default AgendamientoVentaPage;